import axios from 'axios';
import properties from '../../properties';
import { FixedCostFeeCalculation } from '../../../pages/FinancialForensicsPage/types/FixedCost.types';
import { StopLossVendor } from '../../../pages/FinancialForensicsPage/types/StopLoss.types';

export const getFinancialForensicsData = async (
  egNid: string,
  startDate: string,
  endDate: string,
  max_claim_date: string,
  isMainPage: boolean = false,
) => {
  return await axios.post(
    properties.aiqBaseUrl + properties.financialForensicsBaseURL,
    {
      eg_nid: [egNid],
      startDate,
      endDate,
      max_claim_date,
      isMainPage,
    },
  );
};

export const addVendor = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  data: any,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.addVendor,
    { eg_nid, startDate, endDate, vendorType, data },
  );
};

export const updateVendor = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  data: any,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateVendor,
    { eg_nid, startDate, endDate, vendorType, data },
  );
};

export const addClaims = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  data: any,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.addClaims,
    { eg_nid, startDate, endDate, vendorType, data },
  );
};

export const updateClaims = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  data: any,
  vendorID: string,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateClaims,
    { eg_nid, startDate, endDate, vendorType, data, vendorID },
  );
};
export const addRebates = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  data: any,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.addRebates,
    { eg_nid, startDate, endDate, data },
  );
};

export const updateRebates = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  data: any,
  vendorID: any,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateRebates,
    { eg_nid, startDate, endDate, data, vendorID },
  );
};

export const deleteVendor = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  vendorID: string,
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.deleteVendor,
    { eg_nid, startDate, endDate, vendorType, vendorID },
  );
};

export const updateFeeCalculationVendor = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  vendorID: string,
  serviceID: string,
  feeCalculation: FixedCostFeeCalculation,
  updatedFee: number,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateFeeCalculationVendor,
    {
      eg_nid,
      startDate,
      endDate,
      vendorType,
      vendorID,
      serviceID,
      feeCalculation,
      updatedFee,
    },
  );
};

export const getAvailableDates = (eg_nid: string, signal?: AbortSignal) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.getAvailableDates,
    { eg_nid },
    { signal },
  );
};

export const addPlanDates = (
  eg_nid: string,
  startDate: string,
  endDate: string,
) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.addNewPlanDates,
    { eg_nid, startDate, endDate },
  );
};

export const deleteClaim = (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorType: string,
  vendorID: string,
) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.deleteClaims,
    { eg_nid, startDate, endDate, vendorType, vendorID },
  );
};

export const deleteRebates = (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorID: string,
) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.deleteRebates,
    { eg_nid, startDate, endDate, vendorID },
  );
};

export const uploadFiscalControlFiles = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  userId: string,
  files: File[],
) => {
  const formData = new FormData();
  formData.append('eg_nid', eg_nid);
  formData.append('startDate', startDate);
  formData.append('endDate', endDate);
  formData.append('userId', userId);

  if (files && Array.isArray(files)) {
    files.forEach((file: File) => {
      formData.append('files', file);
    });
  }

  return await axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.uploadFiscalControlFiles,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const deleteFiscalControlFile = (
  eg_nid: string,
  startDate: string,
  endDate: string,
  fileId: string,
) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.deleteFiscalControlFiles,
    { eg_nid, startDate, endDate, fileId },
  );
};

export const addStopLossVendor = (
  eg_nid: string,
  startDate: string,
  endDate: string,
  data: StopLossVendor,
) => {
  return axios.post(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.addStopLossVendor,
    { eg_nid, startDate, endDate, data },
  );
};
export const updateStoplossVendor = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  data: any,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateStopLossVendor,
    { eg_nid, startDate, endDate, data },
  );
};
export const updateFeeCalculationStoploss = async (
  eg_nid: string,
  startDate: string,
  endDate: string,
  vendorID: string,
  subscriptionID: string,
  feeCalculation: FixedCostFeeCalculation,
  updatedFee: number,
) => {
  return await axios.put(
    properties.aiqBaseUrl +
      properties.financialForensicsBaseURL +
      properties.updateFeeCalculationStoploss,
    {
      eg_nid,
      startDate,
      endDate,
      vendorID,
      subscriptionID,
      feeCalculation,
      updatedFee,
    },
  );
};
